window.urlFormatter = function(value, row) {
    if (value) {
        return '<a href="' + value + '" target="_blank" rel="noopener noreferrer">' + value + "</a>";
    }
};
